import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const getPurchases = createAsyncThunk('purchases/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/purchases/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    // return custom error message from API if any
    if (error.response && error.response.data.detail) {
      return rejectWithValue(error.response.data.detail)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

export const savePurchase = createAsyncThunk(
  'purchase/save',
  async (purchase, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.put(`/api/purchases/${purchase.id}/`, purchase)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const createPurchase = createAsyncThunk(
  'purchase/create',
  async (purchase, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      console.log(purchase)
      const { data } = await axios.post('/api/purchases/', purchase)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const deletePurchase = createAsyncThunk(
  'purchase/delete',
  async (purchase, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/purchases/${purchase.id}/`)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)
